import {createContext, useContext} from 'react';

interface RoomSlugResolution {
    roomId: string;
    presenterCode?: string;
    params: {key: string; value: string}[];
}

const RoomSlugResolutionContext = createContext<RoomSlugResolution | null>(null);

export const useRoomSlugResolution = (): RoomSlugResolution | null => useContext(RoomSlugResolutionContext);

export default RoomSlugResolutionContext;
